import { Component, OnInit } from '@angular/core';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { DatePipe } from '@angular/common';
import { AppConstants, DATEPICKER, LOGON_INFO, USER_TYPE } from '../app.constants';
import { CommonService } from '../app.service';
import { MessageService } from '../common/message.service';
import { StatisticService } from './statistic.service';
import $ from 'jquery';


@Component({
    selector: 'statistic',
    templateUrl: 'statistic.component.html',
    providers: [ StatisticService ]
})
export class StatisticComponent implements OnInit {

    LOGON_INFO: any = LOGON_INFO;
    USER_TYPE: any = USER_TYPE;

    date_type: string;
    fileName: string;
    
    statistic_type: string = "";

    start_date: any;
    end_date: any;

    start_year: number;
    start_month: number;
    end_year: number;
    end_month: number;

    yearList: number[] = [];

    titleList: any;
    resultList: any;

    datePickerOptions: INgxMyDpOptions = DATEPICKER.myDatePickerOptions_noDisableUntil;


    constructor(
        private statisticService: StatisticService,
        private commonService: CommonService,
        private msgService: MessageService,
        private datePipe: DatePipe
    ) {  }
 

    ngOnInit() {
        let today = new Date();

        for (var i=AppConstants.LAUNCHING_YEAR; i<=today.getFullYear(); i++) {
            this.yearList.push(i);
        }

        this.start_year = today.getFullYear();
        this.start_month = today.getMonth() + 1;
        this.end_year = today.getFullYear();
        this.end_month = today.getMonth() + 1;

        let sd = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        let ed = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        this.start_date = { jsdate: sd, formatted: this.datePipe.transform(sd, 'yyyyMMdd') };
        this.end_date = { jsdate: ed, formatted: this.datePipe.transform(ed, 'yyyyMMdd') };

        this.date_type = 'yyyymm';
    }



    setDateTypeValue(type: string) {
        this.date_type = type;
    }




    searchStatistic() {
        if (this.date_type == 'yyyymm') {
            let sd = new Date(this.start_year, this.start_month - 1, 1);
            let ed = new Date(this.end_year, this.end_month, 0);
            this.start_date = { jsdate: sd, formatted: this.datePipe.transform(sd, 'yyyyMMdd') };
            this.end_date = { jsdate: ed, formatted: this.datePipe.transform(ed, 'yyyyMMdd') };
        }

        if (!this.commonService.checkStartEndDate(this.start_date, null, this.end_date, null, true, false, true)) {
            return;
        }

        this.fileName = $('#statistic_type option:selected').text() + "_" + this.start_date.formatted + "～" + this.end_date.formatted;

        this.statisticService.getStatistic(this.statistic_type, this.start_date.formatted, this.end_date.formatted)
        .subscribe(
            data => {
                this.titleList = data['results'].shift();
                this.resultList = data['results'];
                this.msgService.clearError();
            }
        );
    }




    //EXCEL出力
    exportAsExcel() {
        if (this.fileName) {
            let targetList = [this.titleList].concat(this.resultList);
            this.commonService.exportAsExcelFile(targetList, this.fileName, true);
        }
        else {
            this.msgService.addError("出力対象データの検索を行ってください。");
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/statistic/statistic.component.ts